import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as theme from '../theme'
import { getColorsFromOrder } from '../utils/getColorsFromOrder'

/**
 * Primary UI component for user interaction
 */

const Wrapper = styled.div`
   border-radius: 50%;
   width: ${props => props.size.width};
   height: ${props => props.size.width};
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: ${props => props.size.fontSize};
   font-weight: bold;
   color: ${theme.color.white};
   background: ${props => props.background};
`

/**
 * Get initials from name
 * @param name { string }
 * @return {string}
 */
const getInitials = name => {
   const initials = name.match(/\b\w/g) || []
   return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()
}

export const Avatar = ({ name, childOrder, size, ...props }) => {
   const initials = getInitials(name)
   const colors = getColorsFromOrder(childOrder)
   const sizeValues = getSize(size)

   return (
      <Wrapper background={colors.color} size={sizeValues}>
         <span>{initials}</span>
      </Wrapper>
   )
}

const getSize = size => {
   switch (size) {
      case 'small':
         return { width: '35px', fontSize: theme.fontSize.s }
      case 'medium':
         return { width: '40px', fontSize: theme.fontSize.sm }
      case 'large':
         return { width: '60px', fontSize: theme.fontSize.ml }
      default:
         return { width: '40px', fontSize: theme.fontSize.s }
   }
}

Avatar.propTypes = {
   /**
    * Avatar name
    */
   name: PropTypes.string.isRequired,
   /**
    * Child order
    */
   childOrder: PropTypes.number.isRequired,
   /**
    * How large should the button be?
    */
   size: PropTypes.oneOf(['small', 'medium', 'large'])
}

Avatar.defaultProps = {
   name: 'Förnamn Efternamn',
   childOrder: 1,
   size: 'medium'
}
